<template>
  <div>
    <div v-if="!isPasswordReset">
      <form>
        <h2>Reset your password</h2>
        <text-input
          :auto-focus="true"
          :value="email"
          placeholder="johnsmith@example.com"
          label="Email address"
          name="email"
          type="email"
          :error="!isValidEmail"
          validation-message="A valid email is required"
          @input="email = $event"
          @enter="requestPasswordReset"
        />
        <loading-button
          :disabled="!isValidEmail"
          :loading="loading"
          @click="requestPasswordReset"
        >
          Reset password
        </loading-button>
      </form>
    </div>
    <div v-if="isPasswordReset">
      <h4>Check your inbox!</h4>
      <p>
        A link to reset your password has been sent to <b>{{ email }}</b>
      </p>
    </div>
  </div>
</template>

<script>
import { LoadingButton, TextInput } from '@inscribe/ui-kit';
import { $event } from '../bus';
import { isValidEmail } from '../utils/validation';

export default {
  components: {
    'loading-button': LoadingButton,
    'text-input': TextInput,
  },
  data() {
    return {
      email: '',
      loading: false,
      isPasswordReset: false,
    };
  },
  computed: {
    isValidEmail() {
      return isValidEmail(this.email);
    },
  },
  methods: {
    requestPasswordReset() {
      if (this.isValidEmail) {
        const data = new FormData();
        data.append('email', this.email);
        this.loading = true;
        this.$store
          .dispatch('requestPasswordReset', data)
          .then((response) => {
            this.loading = false;
            this.isPasswordReset = true;
          })
          .catch((error) => {
            $event.$emit('preloader.off');
            this.$notify({
              group: 'general',
              type: 'error',
              title: 'There was a problem requesting a password reset link',
              duration: 5000,
              text: error.response.data.message,
            });
          });
      }
    },
  },
};
</script>
